import React, { useRef } from 'react';
import { H2, H3, Span, Strong } from '../../../shared_components/Library/Typeography';
import { Box } from '../../../shared_components/UI/Box';
import ScheduleGraph from './ScheduleGraph';
import styled from 'styled-components';
import SegmentedControl from '../../../shared_components/Library/SegmentedControl';
import { MaxWidth } from '../../../shared_components/Page';
import { useStakingContext } from '../../../contexts/StakingContext';

function StakingVestingShedule() {
  return (
    <MaxWidth maxWidth={1104}>
      <Box dc padV="section" g={24} c>
        <H2 s="3XL" fw="bolder" uc c="text-primary" ff="Proxima Nova">Vesting Schedule</H2>
        <PureVestingSchedule showControls={false} />
      </Box>
    </MaxWidth>
  );
}

export function PureVestingSchedule({ showControls = true }: { showControls?: boolean }) {
  const { totalTokensVested } = useStakingContext()
  const seedRef = useRef(null)
  const strategicRef = useRef(null)

  const isSeed = false
  const isStrategic = false

  return (
    <GraphCont dc g={16}>
      <Box ac jsb>
        <Box dc g={4}>
          <Span s="M" c="text-secondary" fw="regular">Vested so far</Span>
          <Box ac g={4}>
            <img src="/zap-coin-yellow-bg.svg" alt="zap coin logo" />
            <H3 s="XL" fw="semibold" c="text-primary">{totalTokensVested.toLocaleString()}</H3>
          </Box>
        </Box>
        {showControls && (
          <Box fu aw>
            <SegmentedControl
              name="vesting-schedule-control"
              segments={[
                { value: 'seed', label: 'Seed', ref: seedRef },
                { value: 'strategic', label: 'Strategic', ref: strategicRef },
              ]}
              callback={(value) => {
                console.log('SegmentedControl value:', value);
              }}
            />
          </Box>
        )}
      </Box>
      {/* <ScheduleGraph /> */}
    </GraphCont>
  )
}

export default StakingVestingShedule

const GraphCont = styled(Box)`
  padding: var(--units-24, 24px) var(--units-16, 16px);
  border-radius: var(--units-12, 12px);
  border: var(--units-1, 1px) solid var(--stroke-tertiary, #252525);
  gap: var(--units-16, 16px);
`
